import { css } from '@emotion/react'
import React from 'react'
import { SummaryLabel } from './OverseasCompanySummary'
import { font } from 'plume-ui'

type Props = {
  start?: number
  end?: number
  className?: string
}

export const EmployeesNumber: React.VFC<Props> = (props) => {
  const hasValue = props.start || props.end
  return (
    <div
      className={props.className}
      css={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
      `}
    >
      <SummaryLabel>従業員数</SummaryLabel>
      <div
        css={css`
          font-style: normal;
          font-weight: ${font.weight.normal};
          font-size: 32px;
          height: 48px;
          line-height: 75%;
          text-align: center;
          display: flex;
          align-items: center;
        `}
      >
        <div
          css={css`
            display: flex;
            align-items: baseline;
          `}
        >
          {hasValue ? `${props.start ?? ''}-${props.end ?? ''}` : '-'}
          {hasValue && (
            <span
              css={css`
                display: inline-block;
                font-size: 16px;
                line-height: 100%;
                margin-left: 4px;
                vertical-align: bottom;
              `}
            >
              人
            </span>
          )}
        </div>
      </div>
    </div>
  )
}
